import { Navigate, Outlet, useLocation } from 'react-router-dom';

import CenteredProgressIndicator from '@/components/ProgressIndicator';
import useAuth from '@/hooks/useAuth';
import useReturnTo from '@/hooks/useReturnTo';
import { useUser } from '@/hooks/useUser';

/**
 * Requires that the user is logged in as a DNB user before displaying the protected resource.
 *
 * Redirects to login page if the user is not logged in.
 * Redirects to the 404 page if the user is logged in, but not a DNB user.
 */
export default function InternalRoutes() {
  const { isLoading, isLoggedIn } = useUser();
  const { pathname } = useLocation();
  const [, setReturnTo] = useReturnTo();
  const { isInternal } = useAuth();

  if (isLoading) return <CenteredProgressIndicator />;

  if (!isLoggedIn) {
    setReturnTo(pathname);
    return <Navigate to="/login" />;
  }

  return isInternal ? <Outlet /> : <Navigate to="/404" />;
}
